<template>
    <ElTooltip
        v-if="MultiMonitorServiceInstance.isParentActive"
        ref="multiMonitorToggle"
        :visibleArrow="false"
        :enterable="false"
        :openDelay="popperOpenDelay"
        :content="tooltipContent"
        placement="top"
        effect="dark"
    >
        <div
            :class="{
                'multi-monitor-toggle': true,
                'multi-monitor-toggle--active': patentId === MultiMonitorServiceInstance.activeId
            }"
            @click.stop.prevent="toggle"
        >
            <PtIcon icon="SolidMultiMonitor" />
        </div>
    </ElTooltip>
</template>

<script>
import MultiMonitorServiceInstance from './multi-monitor-service';
import { Icon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/MultiMonitor.svg';
import { Tooltip } from 'element-ui';
import { POPPER_OPEN_DELAY } from '@/constants';
import _ from 'lodash';

export default {
    name: 'MultiMonitorToggle',
    components: {
        PtIcon: Icon,
        ElTooltip: Tooltip,
    },
    props: {
        patentId: {
            type: String,
            required: true,
        },
        isInPatentList: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            MultiMonitorServiceInstance,
        };
    },
    computed: {
        tooltipContent() {
            if (this.patentId === MultiMonitorServiceInstance.activeId) return this.$t('patent-view.multiMonitor.toggledChild');
            // 如果是右侧列表中的入口，文案需要特殊展示
            return this.isInPatentList ? this.$t('patent-view.multiMonitor.viewInList') : this.$t('patent-view.multiMonitor.toggleChild');
        },
    },
    created() {
        this.popperOpenDelay = POPPER_OPEN_DELAY;
    },
    methods: {
        toggle() {
            if (!this.isInPatentList) MultiMonitorServiceInstance.parent__triggerChildToggleCallback(this.patentId);
            // Fix tooltip 在 focus 状态下会展示 （手动清除 focus 状态）
            const multiMonitorTriggerEl = _.get(this, '$refs.multiMonitorToggle.$el');
            multiMonitorTriggerEl && multiMonitorTriggerEl.blur();
            window.rvTrack('MultiMode Toggle Children Patent');
        },
    },
};
</script>

<style lang="scss">
.multi-monitor-toggle {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    border-radius: 4px;
    &:hover {
        background-color: $border-light;
    }
    .patsnap-biz-icon {
        font-size: 24px;
        margin-bottom: 0;
        color: $fill-normal !important;
    }
    &--active {
        .patsnap-biz-icon {
            color: $status-success-primary !important;
        }
    }
}
</style>
